export default __webpack_public_path__ + "static/media/reusable-cup.8381b17d.png";